import { Button } from "@/components/ui/button";
import { useRetryDemoSpace } from "@/features/admin";
import { RotateCw } from "lucide-react";
import { toast } from "sonner";

export const RetryButton = ({ id }: { id: string }) => {
  const retry = useRetryDemoSpace();

  return (
    <Button
      size="sm"
      variant="outline"
      disabled={retry.isPending}
      onClick={async () => {
        try {
          await retry.mutateAsync(id);
        } catch (error) {
          toast.error(error instanceof Error ? error.message : "Échec");
        }
      }}
    >
      <RotateCw className="h-3.5 w-3.5" />
      Relancer
    </Button>
  );
};
